import React, { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { Apirequests } from '../../utils/ApiRequests';
import SpinningLogo from '../../components/Spinner';

const SalesChart = () => {
  const [data, setData] = useState([]);
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);

  // Group orders by date and calculate success/failure amounts
  // const processedData = orders.reduce((acc, order) => {
  //   const date = new Date(order.createdAt).toLocaleDateString('en-US', {
  //     month: 'short',
  //     day: 'numeric'
  //   });

  //   if (!acc[date]) {
  //     acc[date] = {
  //       date,
  //       successful: 0,
  //       failed: 0
  //     };
  //   }

  //   if (order.status === 'captured') {
  //     acc[date].successful += parseFloat(order.amount);
  //   } else {
  //     acc[date].failed -= parseFloat(order.amount); // Negative for failed orders
  //   }

  //   return acc;
  // }, {});


  // console.log(chartData,'chart')

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await Apirequests(`orders/get-orders-days?days=10`, 'GET', {}, {
        Authorization: `Bearer ${token}`
      });
      // console.log(res,'res days orders');
      if (res.success) {
        setData(res?.data)
      } else {
        setData([])
      }
    } catch (error) {
      console.log(error, 'error fetching orders by days');
    }
    setLoading(false)
  };

  useEffect(() => {
    fetchData();
  }, []);

  const chartData = Object.values(data);


  if (loading) {
    return <div className='h-screen w-full flex items-center justify-center bg-[rgba(255,255,255,0.5)]'>
      <SpinningLogo />
    </div>
  }


  return (
    <div className="w-full h-96 p-4 bg-white rounded-lg shadow-lg">
      {/* <h2 className="text-xl font-bold text-gray-800 mb-4">Orders Analysis</h2> */}
      <ResponsiveContainer width="100%" height="90%">
        <BarChart
          data={chartData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip
            contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #ccc',
              borderRadius: '4px'
            }}
          />
          <Legend />
          <Bar
            dataKey="successful"
            fill="#4ade80"
            name="Successful Orders ₹"
            radius={[4, 4, 0, 0]}
          />
          <Bar
            dataKey="failed"
            fill="#ef4444"
            name="Failed Orders ₹"
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SalesChart;